module.exports = __webpack_public_path__ + "img/SmartSalesLogo2.3b7520c6.png";